import { Button } from "@mui/material";
import { styled } from "@mui/styles";
import { useFormikContext } from "formik";
import { FC, useEffect, useState } from "react";
import useLocales from "../../hooks/useLocales";

const BootstrapButton = styled(Button)({
  boxShadow: "none",
  fontSize: 16,
  padding: "6px 12px",
  lineHeight: 1.5,
  position: "relative",
  height: "50px",
  "&:focus": {
    boxShadow: "0 0 0 0.2rem rgba(0,123,255,.5)",
  },
});

interface IApplyFilterButton {
  submitHandler?: (values: any) => void;
  disable?: boolean;
}

const ApplyFilterButton: FC<IApplyFilterButton> = ({
  submitHandler,
  disable = true,
}) => {
  const { translate } = useLocales();
  const formik: any = useFormikContext();
  const [success, setSuccess] = useState<boolean>(false);

  const buttonSx = {
    ...(success && {
      bgcolor: "#0033A1",
      textAlign: "center",
      "&:hover": {
        bgcolor: "#0033A1",
      },
    }),
  };

  useEffect(() => {
    if (formik.isSubmitting) {
      setSuccess(false);
    } else {
      setSuccess(true);
    }
  }, [formik.dirty, formik.isSubmitting]);

  return (
    <div style={{ textAlign: "center" }}>
      <BootstrapButton
        variant="contained"
        id="applyButton"
        size="large"
        type={submitHandler ? undefined : "submit"}
        onClick={submitHandler}
        style={{ minWidth: "200px" }}
        sx={buttonSx}
        disabled={disable ? !formik.dirty : false}
      >
        {translate("actions.filter")}
      </BootstrapButton>
    </div>
  );
};
export default ApplyFilterButton;
